<template>
  <div class="container">
    <v-container>
      <v-row align="center" justify="center">
        <v-col :lg="6" :sm="12">
          <v-card class="elevation-6 mt-12 rounded-xl">
            <v-row>
              <v-col cols="12" sm="12">
                <v-card-title align="center" class="mt-4">
                  <v-img src="/img/logo.png" :width="230" aspect-ratio="16/9" cover></v-img>
                </v-card-title>
                <v-card-text class="mt-2">
                  <h2 class="text-center text-primary-lighten-1">
                    ¡Bienvenido a nuestro programa!
                  </h2>
                  <h4 class="text-center grey--text">
                    <br />
                    Ingresa tus datos y te contactaremos

                  </h4>
                  <h4 class="text-center grey--text">
                    O comuníquese con nosotros al teléfono
                    <a href="tel:+56229447439">229447439</a>
                  </h4>
                  <v-row align="center" justify="center">
                    <v-col cols="12" sm="8">
                      <v-form ref="form" @submit.prevent="submitForm">
                        <v-list>
                          <v-combobox label="Medicamento *" base-color="black" :items="data.medicamentos" color="blue"
                            v-model="data.programaMedicamento"
                            :rules="[data.required('Medicamento'), data.validarMedicamento, data.counter(70)]"
                            maxlength="70" counter></v-combobox>
                          <v-text-field v-model="data.nombresPaciente" label="Nombres *"
                            :rules="[data.required('Nombres'), data.counter(100)]" outlined dense color="blue"
                            autocomplete="false" maxlength="100" counter required />
                          <v-text-field v-model="data.apellidosPaciente" label="Apellidos *"
                            :rules="[data.required('Apellidos'), data.counter(100)]" outlined dense color="blue"
                            autocomplete="false" maxlength="100" counter />
                          <v-text-field v-model="data.telefonoPaciente1" label="Teléfono 1 *"
                            :rules="[data.required('Teléfono 1'), data.counter(10)]" outlined dense color="blue"
                            autocomplete="false" counter maxlength="10" type="number" />
                          <v-text-field v-model="data.telefonoPaciente2" label="Teléfono 2" outlined dense color="blue"
                            :rules="[data.counter(10)]" autocomplete="false" type="number" maxlength="10" counter />
                          <v-text-field v-model="data.nombreTutor" label="Nombre tutor" :rules="[data.counter(200)]"
                            outlined dense color="blue" autocomplete="false" maxlength="200" counter />
                          <v-text-field v-model="data.telefonoTutor" label="Teléfono tutor" outlined dense color="blue"
                            :rules="[data.counter(10)]" autocomplete="false" maxlength="10" type="number" counter />
                          <v-text-field v-model="data.nombreMedicoTratante" label="Nombre médico tratante *"
                            :rules="[data.required('Nombre médico tratante'), data.counter(200)]" outlined dense
                            color="blue" autocomplete="false" maxlength="200" counter />
                          <!-- <v-text-field v-model="data.email" label="Email *"
                            :rules="[data.required('Email'), data.emailRules, data.counter(200)]" outlined dense
                            color="blue" autocomplete="false" type="email" maxlength="200" counter /> -->
                          <v-combobox label="Comuna de residencia" hint="Nota: Seleccione o escriba en su teclado"
                            v-model="data.comuna" persistent-hint small-chips hide-selected :items="comunas_chile"
                            :hide-no-data="false" color="blue" class="mb-4" maxlength="150" :rules="[data.counter(150)]"
                            counter />
                          <!-- <v-combobox label="Representante *" base-color="black" :items="data.representantes" color="blue"
                            v-model="data.programaRepresentante"
                            :rules="[data.required('Representante'), data.validarRepresentante, data.counter(70)]"
                            maxlength="70" counter></v-combobox> -->
                          <v-textarea clearable label="Observaciones" v-model="data.observaciones" color="blue"
                            clear-icon="mdi-close-circle" maxlength="300" :rules="[data.counter(300)]" counter />
                          <v-file-input accept="image/*, .pdf" v-model:model-value="data.file"
                            label="Suba la imagen de su receta médica" @change="onFileChange" />
                          <v-checkbox v-model="data.consentimiento">
                            <template v-slot:label>
                              <div>
                                Acepto los
                                <a href="#" @click.stop.prevent="formProp.dialog = true">
                                  Términos y Condiciones
                                </a>
                                *
                                <v-dialog v-model="formProp.dialog" max-width="600" content-class="no-outer-scroll">
                                  <v-card class="d-flex flex-column" max-height="80vh">
                                    <v-card-title class="headline">
                                      DECLARACIÓN DE CONSENTIMIENTO INFORMADO
                                    </v-card-title>

                                    <v-divider />

                                    <!-- ÚNICA zona con scroll -->
                                    <v-card-text class="flex-1-1 auto overflow-y-auto">
                                      <div class="declaration-content">
                                        <p>Acepto libre y voluntariamente participar en el Programa de Soporte a
                                          Pacientes del Laboratorio
                                          MSN, comprendiendo que este programa tiene un carácter complementario y no
                                          reemplaza las
                                          indicaciones, diagnósticos ni tratamientos entregados por mi médico
                                          tratante.</p>
                                        <p>Autorizo expresamente que me contacten con el fin de entregarme los
                                          beneficios asociados al
                                          programa de soporte, incluyendo orientación, seguimiento y acompañamiento en
                                          relación con
                                          mi tratamiento médico prescrito.</p>
                                        <p>Asimismo, autorizo al administrador del Programa de pacientes Pasión por
                                          Cuidarte a recopilar,
                                          registrar y analizar la información que yo, o mi representante legal,
                                          entreguemos, con el
                                          objetivo de prestar correctamente los servicios del programa. Esta
                                          información podrá ser
                                          comunicada al Laboratorio MSN y a terceros que actúen en su nombre, en caso
                                          de ser necesario
                                          para reportar eventos adversos asociados al medicamento, conforme a la
                                          normativa vigente en
                                          Chile y en otros países donde corresponda.</p>
                                        <p>El administrador del programa se compromete a proteger la confidencialidad
                                          de mis datos
                                          personales, en cumplimiento con la Ley N°19.628 sobre Protección de la Vida
                                          Privada y demás
                                          regulaciones aplicables.</p>
                                        <p>Podré solicitar en cualquier momento la eliminación de mis datos personales
                                          (salvo aquellos que
                                          deban conservarse por obligaciones legales y/o regulatorias), llamando al
                                          número 229447439.</p>
                                        <p>Al enviar y completar el formulario, declaro haber leído y comprendido esta
                                          declaración y
                                          acepto las condiciones aquí descritas.</p>
                                      </div>
                                    </v-card-text>

                                    <v-divider />

                                    <v-card-actions>
                                      <v-spacer />
                                      <v-btn color="primary" @click="formProp.dialog = false">Cerrar</v-btn>
                                    </v-card-actions>
                                  </v-card>
                                </v-dialog>
                              </div>
                            </template>
                          </v-checkbox>
                        </v-list>
                        <v-btn type="submit" color="blue" dark block tile :disabled="formProp.loading"
                          :loading="formProp.loading">
                          Registrar
                        </v-btn>
                        <v-snackbar v-model="formProp.snackbar">
                          {{ formProp.snackbarText }}
                          <template v-slot:actions>
                            <v-btn color="blue" variant="text" @click="formProp.snackbar = false">
                              <v-icon icon="mdi-close"></v-icon>
                            </v-btn>
                          </template>
                        </v-snackbar>
                      </v-form>
                      <p>* Campos obligatorios</p>
                      <div class="d-flex justify-space-between align-center mx-10 mb-16"></div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import { VForm } from "vuetify/lib/components/index.mjs";
import imageCompression from 'browser-image-compression';


useHead({
  title: "MSN | Registro de Pacientes",
});

const MAX_FILE_SIZE_MB = 15; // Tamaño máximo en MB
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024; // Conversión a bytes
const COMPRESS_OPTIONS = {
  maxSizeMB: 1,               // peso objetivo ≈1 MB
  maxWidthOrHeight: 1280,     // redimensiona
  fileType: 'image/webp',     // convierte a WebP
  useWebWorker: true
};

const comunas_chile = [
  "Arica",
  "Camarones",
  "Putre",
  "General Lagos",
  "Alto Hospicio",
  "Iquique",
  "Camiña",
  "Colchane",
  "Pica",
  "Pozo Almonte",
  "Huara",
  "Camina",
  "La Higuera",
  "La Serena",
  "Coquimbo",
  "Andacollo",
  "La Higuera",
  "Vicuña",
  "Illapel",
  "Canela",
  "Los Vilos",
  "Salamanca",
  "Ovalle",
  "Combarbalá",
  "Monte Patria",
  "Punitaqui",
  "Río Hurtado",
  "Limarí",
  "Ovalle",
  "Rapel",
  "Navidad",
  "Litueche",
  "La Estrella",
  "Pichilemu",
  "Marchihue",
  "Paredones",
  "San Fernando",
  "Chépica",
  "Chimbarongo",
  "Lolol",
  "Nancagua",
  "Palmilla",
  "Peralillo",
  "Placilla",
  "Pichidegua",
  "Peumo",
  "Pichidegua",
  "Quinta de Tilcoco",
  "Rancagua",
  "Codegua",
  "Coínco",
  "Coltauco",
  "Doñihue",
  "Graneros",
  "Las Cabras",
  "Machalí",
  "Malloa",
  "Mostazal",
  "Olivar",
  "Peumo",
  "Pichidegua",
  "Quinta de Tilcoco",
  "Rengo",
  "Requínoa",
  "San Vicente",
  "Pichilemu",
  "La Estrella",
  "Litueche",
  "Marchihue",
  "Paredones",
  "San Antonio",
  "Algarrobo",
  "Cartagena",
  "El Quisco",
  "El Tabo",
  "Santo Domingo",
  "San Antonio",
  "Melipilla",
  "María Pinto",
  "Curacaví",
  "Alhué",
  "Buin",
  "Calera de Tango",
  "Paine",
  "San Bernardo",
  "Puente Alto",
  "Pirque",
  "San José de Maipo",
  "Colina",
  "Lampa",
  "Tiltil",
  "San Pedro",
  "Cerrillos",
  "Cerro Navia",
  "Conchalí",
  "El Bosque",
  "Estación Central",
  "Huechuraba",
  "Independencia",
  "La Cisterna",
  "La Florida",
  "La Granja",
  "La Pintana",
  "La Reina",
  "Las Condes",
  "Lo Barnechea",
  "Lo Espejo",
  "Lo Prado",
  "Macul",
  "Maipú",
  "Ñuñoa",
  "Pedro Aguirre Cerda",
  "Peñalolén",
  "Providencia",
  "Pudahuel",
  "Quilicura",
  "Quinta Normal",
  "Recoleta",
  "Renca",
  "San Joaquín",
  "San Miguel",
  "San Ramón",
  "Santiago",
  "Vitacura",
  "El Monte",
  "Isla de Maipo",
  "Padre Hurtado",
  "Peñaflor",
  "Talagante",
  "Coelemu",
  "Coihueco",
  "Chillán",
  "Chillán Viejo",
  "Cobquecura",
  "Coelemu",
  "El Carmen",
  "Ninhue",
  "Ñiquén",
  "Pemuco",
  "Pinto",
  "Portezuelo",
  "Quillón",
  "Quirihue",
  "Ránquil",
  "San Carlos",
  "San Fabián",
  "San Ignacio",
  "San Nicolás",
  "Treguaco",
  "Yungay",
  "Alto Biobío",
  "Antuco",
  "Cabrero",
  "Laja",
  "Los Ángeles",
  "Mulchén",
  "Nacimiento",
  "Negrete",
  "Quilaco",
  "Quilleco",
  "San Rosendo",
  "Santa Bárbara",
  "Tucapel",
  "Yumbel",
  "Concepción",
  "Coronel",
  "Chiguayante",
  "Florida",
  "Hualqui",
  "Lota",
  "Penco",
  "San Pedro de la Paz",
  "Santa Juana",
  "Talcahuano",
  "Tomé",
  "Hualpén",
  "Lebu",
  "Arauco",
  "Cañete",
  "Contulmo",
  "Curanilahue",
  "Los Álamos",
  "Tirúa",
  "Angol",
  "Collipulli",
  "Curacautín",
  "Ercilla",
  "Lonquimay",
  "Los Sauces",
  "Lumaco",
  "Purén",
  "Renaico",
  "Traiguén",
  "Victoria",
  "Temuco",
  "Carahue",
  "Cunco",
  "Curarrehue",
  "Freire",
  "Galvarino",
  "Gorbea",
  "Lautaro",
  "Loncoche",
  "Melipeuco",
  "Nueva Imperial",
  "Padre las Casas",
  "Perquenco",
  "Pitrufquén",
  "Pucón",
  "Saavedra",
  "Teodoro Schmidt",
  "Toltén",
  "Vilcún",
  "Villarrica",
  "Cholchol",
  "Angol",
  "Collipulli",
  "Curacautín",
  "Ercilla",
  "Lonquimay",
  "Los Sauces",
  "Lumaco",
  "Purén",
  "Renaico",
  "Traiguén",
  "Victoria",
  "Valdivia",
  "Corral",
  "Lanco",
  "Los Lagos",
  "Máfil",
  "Mariquina",
  "Paillaco",
  "Panguipulli",
  "La Unión",
  "Futrono",
  "Lago Ranco",
  "Río Bueno",
  "Ancud",
  "Castro",
  "Chonchi",
  "Curaco de Vélez",
  "Dalcahue",
  "Puqueldón",
  "Queilén",
  "Quellón",
  "Quemchi",
  "Quinchao",
  "Osorno",
  "Puerto Octay",
  "Purranque",
  "Puyehue",
  "Río Negro",
  "San Juan de la Costa",
  "San Pablo",
  "Calbuco",
  "Cochamó",
  "Fresia",
  "Frutillar",
  "Llanquihue",
  "Los Muermos",
  "Maullín",
  "Puerto Montt",
  "Puerto Varas",
  "Alerce",
  "La Unión",
  "Lago Ranco",
  "Río Bueno",
  "Ancud",
  "Castro",
  "Chonchi",
  "Curaco de Vélez",
  "Dalcahue",
  "Puqueldón",
  "Queilén",
  "Quellón",
  "Quemchi",
  "Quinchao",
  "Osorno",
  "Puerto Octay",
  "Purranque",
  "Puyehue",
  "Río Negro",
  "San Juan de la Costa",
  "San Pablo",
  "Calbuco",
  "Cochamó",
  "Fresia",
  "Frutillar",
  "Llanquihue",
  "Los Muermos",
  "Maullín",
  "Puerto Montt",
  "Puerto Varas",
];

let form = ref(VForm);
let formProp = ref({
  snackbar: false,
  snackbarText: "",
  loading: false,
  dialog: false
});
let data = ref({
  required: (propertyType: any) => {
    return (v: string) =>
      (v && v.length > 0) || `El campo ${propertyType} es requerido`;
  },
  // emailRules: (value: any) => {
  //   if (/.+@.+\..+/.test(value)) return true;

  //   return "Debe ingresar un email válido.";
  // },
  counter: (max: any) => {
    return (value: any) => value.length <= max || `Excedió el máximo de ${max} caracteres`;
  },
  medicamentos: [
    'Pulmofib'.toUpperCase()
  ],
  validarMedicamento: (value: any) => {
    return data.value.medicamentos.includes(value) || 'Debe seleccionar un medicamento válido';
  },
  // representantes: [
  //   'Familiar',
  //   'Tutor',
  //   'Representante Legal'
  // ],
  // validarRepresentante: (value: any) => {
  //   return data.value.representantes.includes(value) || 'Debe seleccionar un representante válido';
  // },
  nombresPaciente: "",
  apellidosPaciente: "",
  telefonoPaciente1: "",
  telefonoPaciente2: "",
  comuna: "",
  // email: "",
  observaciones: "",
  nombreMedicoTratante: "",
  programaMedicamento: "",
  file: [] as File[],
  consentimiento: false,
  telefonoTutor: "",
  nombreTutor: "",
  // programaRepresentante: ""
});

const clearForm = () => {
  form.value.reset();
  data.value.nombresPaciente = "";
  data.value.apellidosPaciente = "";
  // data.value.email = "";
  data.value.telefonoPaciente1 = "";
  data.value.telefonoPaciente2 = "";
  data.value.file = [];
  data.value.programaMedicamento = "";
  data.value.observaciones = "";
  data.value.nombreMedicoTratante = "";
  data.value.comuna = "";
  data.value.consentimiento = false;
  data.value.telefonoTutor = "",
    data.value.nombreTutor = ""
  // data.value.programaRepresentante = ""
};

const fileToBase64 = (file: File) =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (err) => reject(err);
    reader.readAsDataURL(file);
  });

const submitWithFile = async (imgBase64: any) => {
  return useFetch("/api/mailer", {
    method: "POST",
    body: JSON.stringify({ ...data.value, file: imgBase64 }),
    headers: {
      "Content-Type": "application/json",
    },
    timeout: 15000
  });
};

const submitWithoutFile = async () => {
  return useFetch("/api/mailer", {
    method: "POST",
    body: JSON.stringify({
      ...data.value,
    }),
    headers: {
      "Content-Type": "application/json",
    },
    timeout: 15000
  });
};

const submitForm = async () => {
  /* 1️⃣  Consentimiento obligatorio */
  if (!data.value.consentimiento) {
    formProp.value = {
      ...formProp.value,
      snackbar: true,
      snackbarText: "Debe aceptar los términos y condiciones."
    };
    return;
  }

  formProp.value.loading = true;
  try {
    /* 2️⃣  Validar formulario */
    const { valid } = (await form.value?.validate()) ?? { valid: false };
    if (!valid) throw new Error("Formulario inválido");

    /* 3️⃣  Preparar payload */
    const body: Record<string, unknown> = { ...data.value };

    if (data.value.file.length) {
      // 🔸 el archivo ya viene comprimido/convertido en onFileChange
      body.file = await fileToBase64(data.value.file[0]);
    }

    /* 4️⃣  Enviar */
    const { status } = await useFetch("/api/mailer", {
      method: "POST",
      body: JSON.stringify(body),
      headers: { "Content-Type": "application/json" },
      timeout: 15000
    });

    /* 5️⃣  Feedback */
    formProp.value.snackbar = true;
    if (status.value === "success") {
      formProp.value.snackbarText = "Paciente registrado exitosamente.";
      clearForm();
    } else {
      formProp.value.snackbarText = "Error al registrar el nuevo paciente.";
    }
  } catch (err) {
    formProp.value = {
      ...formProp.value,
      snackbar: true,
      snackbarText: "Ocurrió un error al enviar el formulario."
    };
  } finally {
    formProp.value.loading = false;
  }
};


const onFileChange = async () => {
  try {
    const original = data.value.file?.[0];
    if (!original) return;

    if (original.size > MAX_FILE_SIZE_BYTES) {
      formProp.value = {
        ...formProp.value,
        snackbar: true,
        snackbarText: `El archivo supera ${MAX_FILE_SIZE_MB} MB.`
      };
      data.value.file = [];
      return;
    }

    // 🔸 Comprimir/convertir a WebP
    const compressed = await imageCompression(original, COMPRESS_OPTIONS);

    if (compressed.size > MAX_FILE_SIZE_BYTES) {
      formProp.value = {
        ...formProp.value,
        snackbar: true,
        snackbarText: `Incluso comprimido supera ${MAX_FILE_SIZE_MB} MB.`
      };
      data.value.file = [];
      return;
    }

    data.value.file = [compressed];             // sustituye el archivo
  } catch (e) {
    console.error(e);
    formProp.value = {
      ...formProp.value,
      snackbar: true,
      snackbarText: 'Error al procesar la imagen.'
    };
    data.value.file = [];
  }
};
</script>
<style scoped>
.container {
  background-image: linear-gradient(white, #40337C);
}

.declaration-content {
  max-height: 600px;
  /* Ajusta la altura máxima del contenido aquí */
  overflow-y: auto;
  color: black;
  padding: 20px;
  font-size: 14px;
}

.declaration-content p {
  margin-bottom: 1em;
}

.no-outer-scroll { overflow-y: visible !important; }
</style>
